import React, { useEffect, useState } from 'react'
import { Btn, CustomDropdown, CustomModal, InputText } from '../../../../components'
import { salvarOperacaoMovimentacaoInsumo } from '../../../../services/api/https/system/system.http'

export default function OperacaoMovimentacaoInsumoModal({
  visible = false,
  selectedOperacao = null,
  onResponse,
}) {
  // Hooks
  const [operacao, setOperacao] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      setIsLoading(false)
      selectedOperacao && setOperacao(selectedOperacao)
    }
  }, [visible])

  useEffect(() => {
    if (isLoading) {
      salvarOperacaoMovimentacaoInsumo(operacao)
        .then(operacao => onResponse('success', operacao))
        .catch(e => onResponse('error', e))
    }
  }, [isLoading])
  // Helper
  const onBtnSalvarClick = () => setIsLoading(true)
  // Render
  return (
    <CustomModal
      isVisible={visible}
      onClose={() => onResponse('close')}
      header={operacao ? 'Editando Operação' : 'Nova Operação'}
      width={600}
    >
      <div className="p-grid">
        <div className="p-col-8">
          <InputText
            marginTop={0}
            label={'Operação de Movimentação de Insumo'}
            value={operacao ? operacao.name : ''}
            onChange={value => setOperacao({ ...operacao, name: value })}
          />
        </div>
        <div className="p-col-4">
          <CustomDropdown
            marginTop={0}
            label={'Tipo'}
            value={operacao ? operacao.type : ''}
            onChange={value => setOperacao({ ...operacao, type: value })}
            options={[
              { value: 'entrada', label: 'Entrada' },
              { value: 'saida', label: 'Saída' },
            ]}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
